// Affichage d'un prix de ligne — le cas de la PAIRE OFFERTE.
//
// Depuis le 31/07/2026, un prix de 0 est une valeur légitime : la paire a été
// offerte (cadeau, remplacement, geste commercial), avec un motif obligatoire
// côté serveur. Les écrans l'affichaient jusque-là comme n'importe quel montant,
// c'est-à-dire « 0,00 $ » — indiscernable d'une ligne dont le prix aurait été
// oublié, ou d'un bug. Le propriétaire a signalé exactement cela le 31/07 :
// « ça apparaît avec des incohérences ».
//
// On centralise ici pour que tous les écrans disent LA MÊME CHOSE. Une ligne à
// zéro n'est pas un montant, c'est une décision — elle se lit comme telle.

export const estOfferte = (prix) => Number(prix) === 0;

// Montant formaté, ou « Offerte ». `avecMontant` ajoute « (0 $) » quand le
// support a besoin de rester chiffré (ticket imprimé, export).
export const libellePrix = (prix, { avecMontant = false } = {}) => {
  if (estOfferte(prix)) return avecMontant ? 'Offerte (0 $)' : 'Offerte';
  return Number(prix || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'USD' });
};
